import "./discordButton.css";

export default function Intro() {
  return (
    <div class="cta-wrap">
      <a
        href="https://discord.gg/eSTWbtJ59g"
        target="_blank"
        rel="noopener noreferrer"
        className="join-discord"
      >
        Join the Discord
      </a>
    </div>
  );
}
